import React from "react";
import { ImageOff } from "lucide-react";
import ProductIllustration from "./ProductIllustration";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

/**
 * Renders the product visual.
 *   - image_url is a full http(s) URL or a relative /api/static/... path →
 *     render the real AI-generated product photograph (resolved against
 *     REACT_APP_BACKEND_URL when relative).
 *   - image_url is a "styled://" marker → fall back to the hand-crafted
 *     SVG illustration of the part type.
 *   - image_url is null → "No Image Picture" placeholder.
 */
export default function ProductVisual({ product, className = "" }) {
  const { image_url } = product || {};
  if (!image_url) {
    return (
      <div
        data-testid={`product-visual-empty-${product?.infoshop_pn}`}
        className={`flex flex-col items-center justify-center gap-2 text-slate-400 bg-slate-50 ${className}`}
      >
        <ImageOff size={32} strokeWidth={1.4} />
        <span className="text-xs uppercase tracking-[0.18em] font-semibold">No Image Picture</span>
      </div>
    );
  }

  // Real product photo — either absolute or relative path served by FastAPI.
  if (/^https?:\/\//i.test(image_url) || image_url.startsWith("/api/")) {
    const src = image_url.startsWith("/api/") ? `${BACKEND_URL}${image_url}` : image_url;
    return (
      <img
        src={src}
        alt={product.description}
        loading="lazy"
        data-testid={`product-photo-${product?.infoshop_pn}`}
        className={`w-full h-full object-cover bg-slate-50 ${className}`}
      />
    );
  }

  // styled:// marker → hand-crafted SVG illustration of the actual product
  return <ProductIllustration product={product} className={`w-full h-full ${className}`} />;
}
